import { jsx as b } from "react/jsx-runtime";
import { c as h } from "react/compiler-runtime";
import { Tooltip as m } from "@mui/material";
function T(x) {
  const o = h(20);
  let l, r, e, a;
  o[0] !== x ? ({
    children: l,
    slotProps: e,
    appearance: a,
    ...r
  } = x, o[0] = x, o[1] = l, o[2] = r, o[3] = e, o[4] = a) : (l = o[1], r = o[2], e = o[3], a = o[4]);
  const F = (a === void 0 ? "dark" : a) === "light" ? d.light : d.dark, t = e?.tooltip, i = t && typeof t == "object" && "sx" in t ? t.sx : void 0;
  let p;
  o[5] !== i ? (p = Array.isArray(i) ? i : i != null ? [i] : [], o[5] = i, o[6] = p) : p = o[6];
  let c;
  o[7] !== F || o[8] !== p ? (c = [F, ...p], o[7] = F, o[8] = p, o[9] = c) : c = o[9];
  const g = c;
  let n;
  o[10] !== g || o[11] !== t ? (n = typeof t == "function" ? t : {
    ...t,
    sx: g
  }, o[10] = g, o[11] = t, o[12] = n) : n = o[12];
  let s;
  o[13] !== e || o[14] !== n ? (s = {
    ...e,
    tooltip: n
  }, o[13] = e, o[14] = n, o[15] = s) : s = o[15];
  let f;
  return o[16] !== l || o[17] !== r || o[18] !== s ? (f = /* @__PURE__ */ b(m, { ...r, slotProps: s, children: l }), o[16] = l, o[17] = r, o[18] = s, o[19] = f) : f = o[19], f;
}
const d = {
  dark: {
    fontFamily: "Inter",
    fontSize: "12px",
    lineHeight: 1.5,
    fontWeight: 500,
    backgroundColor: "#272B2F",
    color: "#FFFFFF"
  },
  light: {
    fontFamily: "Inter",
    fontSize: "12px",
    lineHeight: 1.5,
    fontWeight: 500,
    backgroundColor: "#FFFFFF",
    color: "#272B2F",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24)"
  }
};
export {
  T as Tooltip
};
